(function () {
  var root = document.querySelector('[data-byb]');
  if (!root) return;

  var BASE = parseInt(root.getAttribute('data-base-cents'), 10) || 0;
  var ADD_URL = root.getAttribute('data-cart-add') || '/cart/add.js';
  // Tiers must mirror the live automatic Mix & Save discounts.
  var TIERS = [
    // 2026-09-04: EMPTY ON PURPOSE. The last automatic braid discount was switched off
    // (founder: "I'm not giving discount again not now"). The reward is paid in gifts now:
    // 6 packs = 1, 7 packs = 2, handled by cart-gift.js. Do not put a percent back here
    // without switching a matching discount back on in Shopify.
  ];

  var qty = {}; // variantId -> quantity

  var bar = root.querySelector('[data-byb-bar]');
  var countEl = root.querySelector('[data-byb-count]');
  var tierEl = root.querySelector('[data-byb-tier]');
  var totalEl = root.querySelector('[data-byb-total]');
  var addBtn = root.querySelector('[data-byb-add]');

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function currentTier(packs) {
    for (var i = 0; i < TIERS.length; i++) {
      if (packs >= TIERS[i].min) return TIERS[i];
    }
    return null;
  }

  function nextTier(packs) {
    var next = null;
    for (var i = TIERS.length - 1; i >= 0; i--) {
      if (TIERS[i].min > packs) { next = TIERS[i]; break; }
    }
    return next;
  }

  function discountedTotal(gross, pct) {
    return gross - Math.floor(gross * pct / 100);
  }

  function totalPacks() {
    var n = 0;
    for (var id in qty) n += qty[id];
    return n;
  }

  function render() {
    var packs = totalPacks();
    var tier = currentTier(packs);
    var pct = tier ? tier.pct : 0;
    var gross = BASE * packs;
    var net = pct > 0 ? discountedTotal(gross, pct) : gross;

    countEl.textContent = packs + (packs === 1 ? ' pack' : ' packs');

    var next = nextTier(packs);
    if (pct > 0) {
      tierEl.textContent = pct + '% off unlocked';
      tierEl.classList.add('is-unlocked');
    } else if (next) {
      tierEl.textContent = 'Add ' + (next.min - packs) + ' to unlock ' + next.pct + '% off';
      tierEl.classList.remove('is-unlocked');
    } else {
      tierEl.textContent = '';
      tierEl.classList.remove('is-unlocked');
    }

    if (packs === 0) {
      totalEl.textContent = '';
    } else if (pct > 0) {
      totalEl.innerHTML = '<s>' + money(gross) + '</s>' + money(net);
    } else {
      totalEl.textContent = money(net);
    }

    addBtn.disabled = packs === 0;
  }

  function setQty(card, n) {
    var id = card.getAttribute('data-variant-id');
    n = Math.max(0, n);
    qty[id] = n;
    var qtyEl = card.querySelector('[data-byb-qty]');
    var badge = card.querySelector('[data-byb-badge]');
    var minus = card.querySelector('[data-byb-minus]');
    if (qtyEl) qtyEl.textContent = n;
    if (badge) { badge.textContent = n; badge.hidden = n === 0; }
    if (minus) minus.disabled = n === 0;
    card.classList.toggle('is-active', n > 0);
    render();
  }

  root.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-byb-plus]');
    var minus = e.target.closest('[data-byb-minus]');
    if (!plus && !minus) return;
    var card = e.target.closest('[data-byb-shade]');
    if (!card) return;
    var id = card.getAttribute('data-variant-id');
    var cur = qty[id] || 0;
    setQty(card, plus ? cur + 1 : cur - 1);
  });

  addBtn.addEventListener('click', function () {
    var items = [];
    for (var id in qty) {
      if (qty[id] > 0) items.push({ id: Number(id), quantity: qty[id] });
    }
    if (!items.length) return;
    addBtn.classList.add('is-loading');
    addBtn.disabled = true;
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/cart';
    }).catch(function () {
      addBtn.classList.remove('is-loading');
      addBtn.disabled = false;
      alert('Something went wrong adding your box. Please try again.');
    });
  });

  render();
})();
